export default __webpack_public_path__ + "static/media/arve3.7da0842e.jpg";